import { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';

import { FormUserData } from '../../modules/types/types';
import httpClient from '../httpClient';

export const useUserIdData = () => {
  const [formData, setFormData] = useState<FormUserData>({
    cpf: '',
    nomeCompleto: '',
    dataNascimento: '',
    cor: '',
    genero: '',
    ramal: '',
    celular: '',
    emailPessoal: '',
    emailInstitucional: '',
    linkedin: '',
    lattes: '',
    orgaoOrigem: '',
    outroOrgao: '',
    tipoVinculo: '',
    unidadeCadastro: '',
    setor: '',
    dataInicio: '',
    dataFim: '',
    observacoes: '',
    stRegistroAtivo: '',
    papelUsuario: '',
    permissaoUsuario: '',
    moduloUsuario: '',
    create: '',
    read: '',
    update: '',
    delete: '',
  });

  const [loading, setLoading] = useState<boolean>(true);
  const [error, setError] = useState<string | null>(null);

  const { id } = useParams<{ id: string }>();

  useEffect(() => {
    const fetchUserData = async () => {
      if (!id) {
        setError('ID do usuário não encontrado.');
        setLoading(false);
        return;
      }

      try {
        const response = await httpClient.get<FormUserData>(`/api/users/${id}`);

        setFormData(response.data);
        setError(null);
      } catch (err: any) {
        setError(err.message || 'Erro ao obter os dados do usuário.');
        console.error('Erro ao obter dados:', err.message || err);
      } finally {
        setLoading(false);
      }
    };

    fetchUserData();
  }, [id]);

  const updateFormData = (name: keyof FormUserData, value: string | number) => {
    setFormData((prev: FormUserData) => ({
      ...prev,
      [name]: value,
    }));
  };

  return { formData, setFormData, updateFormData, loading, error };
};
